export default "__VITE_ASSET__39e92baa__"